import fetch from 'services/request';
import { ICreditCardSearchParams } from './types';

const API_V1 = '/api/v1';
const REPORT_BASE_URL = `${API_V1}/report`;

const creditCardApis = {
  get: {
    creditCard: (params: ICreditCardSearchParams) => {
      const formattedParams = {
        ...params,
        statuses: params.statuses?.join(','),
      };

      return fetch({
        method: 'get',
        url: `${REPORT_BASE_URL}/credit-card`,
        params: formattedParams,
      });
    },
    summary: (params: { startDate: string; endDate: string }) =>
        fetch({
          method: 'get',
          url: `${REPORT_BASE_URL}/summary-credit-card`,
          params,
        }),
  },
};

export default creditCardApis;
